<template>
  <section>
    <div class="wrapper mb-5 py-4">
      <div class="mx-auto d-table">
        <div class="alert alert-success mt-5">
          <h5 class="alert-heading">Thank you for your purchase</h5>
          <div>We will send you an e-mail & SMS confirmation within 15 minutes.</div>
        </div>

        <!-- NEW TICKET -->
        <div class="wrapper d-none d-md-block" style="padding-top:40px;">
          <div class="final_ticket_new">
            <div class="row mx-0">
              <div class="col-3 px-0 bg-grey cinemas-logo">
                <img :src="finalBookingDetails.HeaderImage" class="img-fluid" alt />
                <div v-if="project == 'ticketak'" class="logo">
                  <img :src="finalBookingDetails.CinemaLogo" class height="50px" width="100px" alt />
                </div>
              </div>
              <div class="col-md-6 py-2 bg-grey">
                <div class="ticket_content">
                  <div class="_title">Cinema</div>
                  <h5>{{ finalBookingDetails.OrgName }}</h5>
                  <div>
                    <span>{{ finalBookingDetails.VoucherText }}</span>
                  </div>

                  <hr class="my-2" />

                  <div class="_title">Voucher Code</div>
                  <p class="mb-3">{{ finalBookingDetails.VoucherCode }}</p>

                  <div class="row mx-0">
                    <div class="col-8 px-0">
                      <div class="_title">
                        <strong>Tickets to be issued</strong>
                      </div>
                      <div class="mb-3">
                        <span>
                          <strong>{{ finalBookingDetails.NoofVouchers }}</strong>
                        </span>
                      </div>
                    </div>

                    <div class="col-4 px-0">
                      <div class="_title">Date of Purchase</div>
                      <div class="mb-3">
                        <span>{{ finalBookingDetails.DateOfPurchase }}</span>
                      </div>
                    </div>
                  </div>

                  <hr class="my-2" />

                  <div class="d-flex justify-content-between mb-3">
                    <div>Total Amount</div>
                    <h6>{{finalBookingDetails.Currency}} {{finalBookingDetails.Total}}</h6>
                  </div>
                  <div class="d-flex justify-content-between">
                    <div style="position: absolute; bottom:0;">
                      *Validity & use of voucher subject to
                      <router-link target="_blank" to="/tnc" class="text-blue">
                        &nbsp;
                        <u>Terms & Conditions</u>
                      </router-link>.
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3 px-0 d-flex flex-column border-left-dashed bg-grey">
                <div class="qrDetails mt-3">
                  <img
                    v-if="project == 'ticketak'"
                    :src="finalBookingDetails.QRCode"
                    class="w-75 mb-2"
                    alt
                  />
                  <!-- <div class="small text-muted">VOUCHER ID</div>
                  <div class="font-weight-bold fs-20">{{finalBookingDetails.ReceiptNo}}</div>-->
                </div>
                <div>
                  <img
                    v-if="project == 'ticketak'"
                    src="@/assets/img/tt-logo_color.png"
                    class="img-fluid"
                    alt
                  />
                  <img v-else src="@/assets/img/myticketi.png" class="img-fluid" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- MOBILE VERSION -->
        <section id="ticket" class="d-md-none mb-2">
          <div class="m_ticket">
            <div class="ticket_img">
              <img :src="finalBookingDetails.HeaderImageMobile" />
              <div class="movie_details p-3">
                <div class="movie_title">{{finalBookingDetails.OrgName}}</div>
                <div class="small">
                  <span>{{ finalBookingDetails.VoucherText }}</span>
                </div>
              </div>
            </div>
            <div class="p-3">
              <div class="d-flex">
                <div class="d-flex align-items-center w-75 position-relative">
                  <!-- <h5 class="ticket-date-box">{{finalBookingDetails.MovieDateDate}}</h5>
                  <div class="ticket-date-content">
                    <div class="lh-1">{{finalBookingDetails.MovieDateMonth}}</div>
                    <div class="lh-1">{{finalBookingDetails.MovieDateDay}}</div>
                  </div>-->
                </div>
                <div class="d-flex">
                  <!-- 
                  <span>&nbsp;</span>-->
                </div>
              </div>

              <hr />

              <div class="d-flex">
                <div class="_title w-50">Date of Purchase</div>
                <div class="w-50">{{finalBookingDetails.DateOfPurchase}}</div>
              </div>

              <hr />

              <div>
                <div class="_title">Voucher Code</div>
                <div>{{finalBookingDetails.VoucherCode}}</div>
              </div>

              <hr />

              <div class="d-flex">
                <div class="w-75">
                  <div class="_title">Tickets to be issued</div>
                  <ul class="selected-seat">
                    <li>{{finalBookingDetails.NoofVouchers}}</li>
                    <!-- <li>J3</li> -->
                  </ul>
                </div>
                <div class="w-25">
                  <div class="_title">Amount</div>
                  <div>{{finalBookingDetails.Currency}} {{finalBookingDetails.Total}}</div>
                </div>
              </div>

              <hr />
              <div class="qrDetails">
                <img
                  v-if="project == 'ticketak'"
                  :src="finalBookingDetails.QRCode"
                  class="w-50 mb-2"
                  alt
                />
                <!-- <div class="small text-muted">BOOKING ID</div>
                <div class="font-weight-bold fs-20">{{finalBookingDetails.ReceiptNo}}</div>-->
                <img
                  v-if="project == 'wanasatime'"
                  src="@/assets/img/myticketi.png"
                  class="img-fluid"
                  width="100px"
                  alt
                />
              </div>
              <div class="d-flex justify-content-between">
                <div class="fs-11">
                  *Validity & use of voucher subject to
                  <router-link target="_blank" to="/tnc" class="text-blue">
                    &nbsp;
                    <u>Terms & Conditions</u>
                  </router-link>.
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- NEW TICKET ENDS -->

        <div class="d-none final_ticket bg-light">
          <div class="row mx-0">
            <div class="col-md-9 py-3">
              <div class="row">
                <div class="col-3">
                  <img :src="finalBookingDetails.Image" class="img-fluid rounded" alt />
                </div>
                <div class="col-9 pr-4">
                  <div>
                    <h5 class="font-weight-">{{finalBookingDetails.Title}}</h5>
                    <div class="mb-1">
                      <span>{{finalBookingDetails.Language}}</span>
                      <span>|</span>
                      <span class="format">{{finalBookingDetails.Format}}</span>
                    </div>
                    <div class="mb-1">
                      <span>{{finalBookingDetails.MovieTiming}}</span>
                      <span class="mx-1"></span>
                      <span>{{finalBookingDetails.MovieDate}}</span>
                    </div>
                    <div
                      class="mb-1"
                    >{{finalBookingDetails.CinemaName}} {{finalBookingDetails.Address}}</div>
                    <div class="small">
                      Seats
                      <span class="font-weight-bold">({{finalBookingDetails.SeatsBooked}})</span>
                    </div>
                    <div>
                      <ul class="list-inline mb-0 small">
                        <li class="list-inline-item mr-1">{{finalBookingDetails.SeatsList}}</li>
                      </ul>
                    </div>
                  </div>

                  <hr class="my-2" />

                  <div>
                    <div class="row">
                      <div class="col-8 small">
                        <div>Ticket Price</div>
                        <!-- <div>Convience Fees</div> -->
                      </div>
                      <div class="col-4 text-right small">
                        <div>{{finalBookingDetails.Currency}} {{finalBookingDetails.Total}}</div>
                        <!-- <div>{{bookingDetails.int}}</div> -->
                      </div>
                    </div>

                    <div class="my-1" style="border-top:1px dashed grey"></div>

                    <div class="row">
                      <div class="col-8 font-weight-bold">Amount Paid</div>
                      <div
                        class="col-4 text-right font-weight-bold"
                      >{{finalBookingDetails.Currency}} {{finalBookingDetails.Total}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-md-3 d-flex flex-column justify-content-center py-3"
              style="border-left:1px dashed grey"
            >
              <div class="qrDetails">
                <img v-if="project == 'ticketak'" src="@/assets/img/qr2.png" class="w-50 mb-2" alt />
                <div class="small text-muted">BOOKING ID</div>
                <div class="font-weight-bold">{{finalBookingDetails.ReceiptNo}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-none">
      <a :href="BookingPDF" target="_blank" class="btn-print">Print</a>
    </div>
    <!--<div v-on:click="printToFile()" class="btn-print">Print</div>-->
  </section>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
import { Printd } from "printd";
import { PROJECT } from "@/helper/constant.js";

export default {
  name: "Offers",

  components: {
    Slick
  },
  data() {
    return {
      reserveId: "",
      token: "",
      project: PROJECT,
      finalBookingDetails: {},
      finalBookingID: "",
      BookingPDF: ""
    };
  },
  mounted() {
    this.reserveId = this.$route.params.reserveId;
    this.token = this.$route.params.token;
    this.finalBookingID = this.$route.params.bookingId;
    this.getBookingDetails();
  },
  methods: {
    printToFile() {
      const cssText = `
          .m_ticket {
    width: 95%;
    overflow: hidden;
    display: table;
    margin: 0 auto;
    max-width: 375px;
    border-radius: 15px;
    border: 1px solid #d3d3d3;
}
.ticket_img {
    height: 165px;
    overflow: hidden;
    position: relative;
}
img {
    vertical-align: middle;
    border-style: none;
}
.ticket_img img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: top;
    object-position: top;
}
.m_ticket .movie_details {
    bottom: 0px;
    width: 100%;
    z-index: 111;
    color: #fff;
    padding: 8px;
    position: absolute;
    letter-spacing: 1px;
}
.p-3 {
    padding: 1rem !important;
}
.ticket_img::after {
    top: 0;
    left: 0;
    width: 100%;
    content: '';
    height: 100%;
    display: block;
    position: absolute;
    background: -o-linear-gradient(bottom, #000000, #00000054, #ffffff00);
    background: -webkit-gradient(linear, left bottom, left top, from(#000000), color-stop(#00000054), to(#ffffff00));
    background: linear-gradient(to top, #000000, #00000054, #ffffff00);
}
.d-flex {
    display: -ms-flexbox !important;
    display: flex !important;
}
.w-75 {
    width: 75% !important;
}
.userDetail, .print-list, .filter-list, .status-filter, .showtime-list, .selected-seat, .select-seat-list, .movie-details-list, .recent-booking-list, .seat-appearance-list, .showtime-list li ol {
    padding-left: 0;
    font-size: 16px;
    margin-bottom: 0;
    list-style: none;
}
.selected-seat li {
    display: inline-block;
}
.w-25 {
    width: 25% !important;
}
.ml-1, .mx-1 {
    margin-left: 0.25rem !important;
}
.m_ticket h5 {
    line-height: 1;
    font-size: 30px;
    margin-bottom: 0;
    font-weight: bold;
}
.lh-1 {
    line-height: 1;
}
.align-items-center {
    -ms-flex-align: center !important;
    align-items: center !important;
}
hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.selected-seat li:nth-last-child(1)::after {
    content: '';
}
.qrDetails {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.mb-2, .my-2 {
    margin-bottom: 0.5rem !important;
}
.text-muted {
    color: #6c757d !important;
}
small, .small {
    font-size: 80%;
    font-weight: 400;
}
.fs-20 {
    font-size: 20px;
}
.font-weight-bold {
    font-weight: 700 !important;
}
.w-50 {
    width: 50% !important;
}
._title {
    color: grey;
    line-height: 1;
    margin-bottom: 5px;
}
.position-relative{
  position: relative;
}
.ticket-date-box {
   
}


.ticket-date-content {
  position: absolute;
  top: 0;
  left: 30px;
}
      `;
      const d = new Printd();
      d.print(document.getElementById("ticket"), [cssText]);
    },
    getBookingDetails: function() {
      let payload = {
        PurchaseID: this.finalBookingID
      };

      makeRequest("/GetVoucherDetails", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          if (!error) {
            this.finalBookingDetails = res.data;
            if (this.project == "ticketak") {
              this.BookingPDF =
                "https://api.ticketak.com/shareticket/" +
                this.finalBookingDetails.BookingID +
                ".pdf";
            } else {
              this.BookingPDF =
                "https://api.mytiketi.com/shareticket/" +
                this.finalBookingDetails.BookingID +
                ".pdf";
            }
            let IHC = window.localStorage.getItem("IHC");
            let sku = window.localStorage.getItem("sku");
            let STP = window.localStorage.getItem("STP");
            let obj = {
              transactionId: this.finalBookingID,
              transactionAffiliation: this.finalBookingDetails.CinemaName,
              transactionTotal: Number(this.finalBookingDetails.Total),
              transcationDate:
                this.finalBookingDetails.MovieDateDate +
                " " +
                this.finalBookingDetails.MovieDateMonth +
                " " +
                this.finalBookingDetails.MovieDateDay +
                " " +
                this.finalBookingDetails.MovieTimingTime,
              transactionTax: Number(IHC),
              transactionProducts: [
                {
                  sku: sku,
                  name: this.finalBookingDetails.Title,
                  price: STP,
                  quantity: this.finalBookingDetails.SeatsBooked
                }
              ]
            };
            console.log("obj :", obj);
            // this.$gtm.push(obj);
            //this.$gtm.trackEvent(obj);
            console.log("ga :", ga);
            ga("send", "event", "Videos", "play", "Fall Campaign");
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          console.log("Error on vue front", error);
        });
    }
  }
};
</script>

<style>
.fs-20 {
  font-size: 20px;
}

.ticket-date-box {
  height: 30px;
  width: 30px;
  display: block;
}
/* .ticket-date-box  */

.ticket-date-content {
  position: absolute;
  top: 0;
  left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ConfirmVoucher.vue